import React from 'react';
import logo from '../images/logo.png';
import './Login.css';
import { buildSafeSameOriginPathRedirectTarget } from '../utils/redirects';

function buildProxySignInUrl() {
  const params = new URLSearchParams(window.location.search);
  const redirectUrl = params.get('redirect_url');
  // Relative: oauth2-proxy drops absolute rd targets that are not whitelisted.
  const target = buildSafeSameOriginPathRedirectTarget(redirectUrl || '/', '/');
  return `/oauth2/sign_in?rd=${encodeURIComponent(target)}`;
}

function ProxyLoginPage() {
  const signInUrl = buildProxySignInUrl();

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="gradient-bg"></div>
        <div className="grid-overlay"></div>
      </div>

      <div className="login-container">
        <div className="login-box">
          <div className="login-brand">
            <img src={logo} alt="Hermetiq" className="login-logo" />
            <h1 className="login-title">Hermetiq</h1>
            <p className="login-tagline">Sign in with your organization identity provider</p>
          </div>

          <div className="login-form">
            <a
              href={signInUrl}
              className="login-button"
              style={{
                display: 'block',
                textAlign: 'center',
                textDecoration: 'none',
                boxSizing: 'border-box',
              }}
            >
              Continue with SSO
            </a>
          </div>

          <div className="login-footer">
            <p>
              For testing, this hands off to OAuth2 Proxy&apos;s sign-in page before redirecting to
              your OIDC provider.
            </p>
          </div>
        </div>
      </div>

      <div className="particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
    </div>
  );
}

export default ProxyLoginPage;
